<template>
  <div v-if="forbidden" style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    ">
    <h1>404</h1>
    <h2>We couldn't find the page you were looking for.</h2>
  </div>
  <div v-else>
      <BContainer>
        <div class="mt-5">
          <FrHeader :title="'Request Status'" :subtitle="'View Process/Task Status here'" />
          <BCard no-body class="card-tabs-vertical">
            <div class="buttonrow">
              <md-button class="md-primary buttonSize" :class="clicked1" @click="activeClicked">Active</md-button>
              <md-button class="md-primary buttonSize" :class="clicked2" @click="completedClicked">Completed</md-button>
            </div>
            <template>
              <div>
                <md-table v-model="searched" md-sort="startTime" md-sort-order="asc" md-card md-fixed-header>
                  <md-table-toolbar class="">
                    <div class="md-layout-item searchrow">
                      <md-field class="searchSize">
                        <label for="movie">Search WorkFlow Name</label>
                        <md-select v-model="filter.workflowName" @input="(value)=>filterChanged(value,'workFlow')" name="movie" id="movie">
                          <md-option v-for="(value,index) in workflowDropDown.keys()" :key="index" :value="value">{{workflowDropDown.get(value)}}</md-option>
                        </md-select>
                      </md-field>
                      <md-field class="searchSize">
                        <label for="movie">{{`Select ${filterLabel} Filter`}}</label>
                        <md-select v-model="RoleEmailFilter" @input="(value)=>filterChanged(value,'searchName')" name="filterRoleEmail" id="filterRoleEmail">
                          <md-option value="email">Email</md-option>
                          <md-option v-if="filter.workflowName === 'roleRequest' || filter.workflowName === 'eaRoleRequest'" value="resourceName">Resource Name</md-option>
                          <md-option v-if="isOpenidmAdmin || isPortalAdmin" value="orgName">Organisation Name</md-option>
                        </md-select>
                      </md-field>
                      <div class="searchSizeButton">
                       <div>
                        <md-chips class="md-primary" v-model="dummyValue" :md-placeholder="placeHolderText" @md-delete="handleChipDelete"
                        @md-insert="handleChipInsert">
                          </md-chips> 
                        <span class="md-helper-text">You may enter multiple search values by pressing enter after each search string.</span>
                      </div>
                      <md-button class="md-primary md-raised" @click="searchValueCall" >Search</md-button>
                    </div>
                    </div>
                  </md-table-toolbar>
                  <template v-if="isLoading">
                    <md-table-row>
                      <md-table-cell colspan="4">
                        <div class="spinner"></div>
                      </md-table-cell>
                    </md-table-row>
                  </template>
                  <template v-else>
                    <template v-if="searched.length === 0">
                      <md-table-row>
                        <md-table-cell colspan="4">
                          <md-table-empty-state md-label="No processes found" :md-description="`No processes found for the search term '${search !== '' ? search : filter.workflowName
                            }'. Try a different search term or create a new process.`"></md-table-empty-state>
                        </md-table-cell>
                      </md-table-row>
                    </template>
                    <template v-else>
                      <md-table-row v-for="item in searched" :key="item.proc_inst_id_" md-selectable="single"
                        :class="{ 'selected-row': item === selectedActive }" @click.native="onSelect(item)">
                        <md-table-cell md-label="Workflow Name" md-sort-by="workflow_name">{{ 
                          item.workflow_name
                        }}</md-table-cell>
                        <md-table-cell md-label="Company" md-sort-by="active_active_Org">{{ 
                          item.organization_name 
                        }}</md-table-cell>
                        <md-table-cell md-label="Email" md-sort-by="email">{{
                          item.email
                        }}</md-table-cell>
                        <md-table-cell md-label="Start Date" md-sort-by="start_time">{{
                          item.start_time
                        }}</md-table-cell>
                        <md-table-cell v-if="filter.completed" md-label="End Date" md-sort-by="end_time">{{
                          item.end_time }}</md-table-cell>
                      </md-table-row>
                    </template>
                  </template>
                </md-table>
                <div class="footerPagination">
                  <md-field class="paginationPageSize">
                    <label for="pageSize">Page Size</label>
                    <md-select v-model="filter.pageSize" name="pageSize" id="pageSize" @input="(value)=>filterChanged(value,'pagination')">
                      <md-option v-for="(value,index) in  paginationArray" :key="index" :value="value">{{value}}</md-option>
                    </md-select>
                  </md-field>
                  <md-button class="paginationStyle" :disabled="!filter.pageOffset" @click="navigateBack"><span
                      class="material-icons">navigate_before</span><md-tooltip
                      md-direction="top">Previous</md-tooltip></md-button>
                  <md-button class="paginationStyle" :disabled="!pagedResultsCookie || pagedResultsCookie < filter.pageSize" @click="navigateNext"><span
                      class="material-icons">navigate_next</span><md-tooltip
                      md-direction="top">Next</md-tooltip></md-button>
                </div>
              </div>
            </template>
          </BCard>
        </div>
      </BContainer>
      <BModal :id="ActiveTaskModalId" :ref="ActiveTaskModalId" title=" Active Task List" size="lg">
        <FRRelationshipViewTaskList :itemSelected="selectedActive" :expandable="true"></FRRelationshipViewTaskList>
        <div slot="modal-footer" class="w-100"></div>
      </BModal>
      <BModal :id="CompletedTaskModalId" :ref="CompletedTaskModalId" title="Completed Task List" size="lg">
        <FRRelationshipViewTaskList :itemSelected="selectedCompleted" :expandable="false"></FRRelationshipViewTaskList>
        <div slot="modal-footer" class="w-100"></div>
      </BModal>
    
  </div>
</template>

<script>
import axios from "axios";
import {BModal} from "bootstrap-vue";
import FrHeader from "@forgerock/platform-shared/src/components/PageHeader";
import RelationshipViewTaskList from "@forgerock/platform-shared/src/components/resource/ViewRelationshipTaskList";
import { generateIdmApi } from "@forgerock/platform-shared/src/api/BaseApi";

export default {
  name: "ProgressSpinnerIndeterminate",
  data() {
    return {
      realmIsEA : (localStorage.getItem('originalLoginRealm') == '/EA' || localStorage.getItem('originalLoginRealm') == 'EA' || localStorage.getItem('originalLoginRealm') == 'EA/') ? true : false,
      paginationArray: [20,50,75,100,150,200],
      forbidden: false,
      search: new Map(),
      searched: [],
      selectedActive: null,
      selectedCompleted: null,
      clicked1: "md-raised",
      clicked2: "",
      isLoading: false,
      pagedResultsCookie: "",
      ActiveTaskModalId: `show_active_task_list`,
      CompletedTaskModalId: `show_completed_task_list`,
      RoleEmailFilter:"resourceName",
      isPortalAdmin: this.$store.state.UserStore.portalAdminUser,
      isOpenidmAdmin: this.$store.state.UserStore.adminUser,
      placeHolderText: "Search Resource Name.",
      filter : {
        otherFilterName: "resourceName",
        otherFilterValue: undefined,
        pageOffset: 0,
        pageSize: 50,
        workflowName: (localStorage.getItem('originalLoginRealm') == '/EA' || localStorage.getItem('originalLoginRealm') == 'EA' || localStorage.getItem('originalLoginRealm') == 'EA/') ? "eaRoleRequest" : "roleRequest",
        completed: false,
      },
      filterLabel:"",
      dummyValue:[],
      placeholderTextMap : new Map([
        ["email", "Search Email."],
        ["resourceName", "Search Resource Name."],
        ["orgName", "Search Organisation Name."]
        ]),
      workflowDropDown :(localStorage.getItem('originalLoginRealm') == '/EA' || localStorage.getItem('originalLoginRealm') == 'EA' || localStorage.getItem('originalLoginRealm') == 'EA/')? 
      new Map([
        ["eaRoleRequest","EA Role Request"],
        ["eaCompanyAddApproval","EA Company Add Approval"],
        ["eaCompanyOfficerAdminOnboard","EA Company Officer Admin Onboard"],
        ["eaCompanyUserOnBoard","EA Company User Onboard"],
        ["eaEmployeeOnBoard","EA Employee Onboard"],
        ["eaOrganizationOnboard","EA Organization Onboard"],
      ])
      : new Map([
        ["roleRequest","Role Request"],
        ["companyAddApproval","Company Add Approval"],
        ["companyOfficerAdminOnboard","Company Officer Admin Onboard"],
        ["companyUserOnBoard","Company User Onboard"],
        ["employeeOnBoar","Employee Onboard"],
        ["engineModelAddApproval","Engine Model Add Approval"],
        ["pnwOrganizationOnboard","PnW Organization Onboard"],
        ["companyAddPortal","Company Add Portal"],
        ["userAddPortalApproval","User Add Portal"],
        ])
    };
  },
  mounted() {
    // console.log(" Open Idm Admin : " , this.isOpenidmAdmin);
    // console.log(" Portal Admin : " , this.isPortalAdmin);
    // console.log("portal Admin : ",  this.$store.state.UserStore.portalAdminUser);
    this.firstPage = true;
    // filter.workflowName ,isPortalAdmin, isOpenidmAdmin
    if(this.isPortalAdmin || this.isOpenidmAdmin && (this.filter.workflowName === "roleRequest" || this.filter.workflowName === "eaRoleRequest")){
      this.filterLabel = "Resource/Email/Organisation"
    } else if (this.isPortalAdmin || this.isOpenidmAdmin && (this.filter.workflowName !== "roleRequest" || this.filter.workflowName !== "eaRoleRequest")) {
      this.filterLabel = "Email/Organisation"
    } else if (!this.isPortalAdmin || !this.isOpenidmAdmin && (this.filter.workflowName === "roleRequest" || this.filter.workflowName === "eaRoleRequest")){
      this.filterLabel = "Resource/Email"
    } else if (!this.isPortalAdmin || !this.isOpenidmAdmin && (this.filter.workflowName !== "roleRequest" || this.filter.workflowName !== "eaRoleRequest")){
      this.filterLabel = "Email"
    }
    this.fetchData();
  },
  components: {
    FrHeader,
    FRRelationshipViewTaskList: RelationshipViewTaskList,
  },
  methods: {
    searchValueCall() {
      this.filter.pageOffset = 0;
      this.fetchData();
    },
    handleChipDelete(text , index){
      this.search.delete(index)
    },
    handleChipInsert(text){
      console.log("text",text , this.dummyValue.length)
      this.search.set(this.dummyValue.length-1,encodeURIComponent(text.trim()))
    },
    filterChanged( value , param) {
      this.filter.pageOffset = 0;
      this.pagedResultsCookie = "";
      if (param === "searchName" || param == "workFlow"){
        if(this.filter.workflowName !== "roleRequest" && param == "workFlow"){
            this.RoleEmailFilter = "email"
        }
        this.search = new Map();
        this.dummyValue = [];
      }
      this.placeHolderText = this.placeholderTextMap.get(this.RoleEmailFilter)
      if(param === "workFlow" || this.search !== "" && !!this.search ){
        this.fetchData();
      }
    },
    navigateBack() {
      if (typeof this.filter.pageSize === "number") {
        // pagesize is a number
        this.filter.pageOffset = this.filter.pageOffset - this.filter.pageSize;
      } else if (typeof this.filter.pageSize === "string") {
        // pagesize is a string
        this.filter.pageOffset = this.filter.pageOffset - parseInt(this.filter.pageSize);
      }
        this.fetchData();
      console.log(this.filter.pageOffset);
    },
    navigateNext() {
      if (typeof this.filter.pageSize === "number") {
        // pagesize is a number
        this.filter.pageOffset = this.filter.pageOffset + this.filter.pageSize;
      } else if (typeof this.filter.pageSize === "string") {
        // pagesize is a string
        this.filter.pageOffset = this.filter.pageOffset + parseInt(this.filter.pageSize);
      }
      this.firstPage = false;
        this.fetchData();
      console.log(this.filter.pageSize);
      console.log(parseInt(this.filter.pageSize));
      console.log(this.filter.pageOffset);
    },
    activeClicked() {
      this.clicked1 = "md-raised";
      this.clicked2 = "";
      this.filter.completed = false;
      this.filter.pageOffset = 0;
      this.pagedResultsCookie = "";
      this.fetchData();
    },
    completedClicked() {
      this.clicked1 = "";
      this.clicked2 = "md-raised";
      this.filter.completed = true;
      this.filter.pageOffset = 0;
      this.pagedResultsCookie = "";
      this.fetchData();
    },
    async fetchData() {

      var otherfilterValueFinal 
      if (this.search.size > 0) {
        var tempSearchArray = Array.from(this.search.values()) 
        if (this.RoleEmailFilter === "orgName") {
          otherfilterValueFinal = tempSearchArray.map(value => value.toUpperCase())
        } else if (this.RoleEmailFilter === "email") {
          otherfilterValueFinal = tempSearchArray.map(value => value.toLowerCase())
        } else {
          otherfilterValueFinal = tempSearchArray
        }
      } else {
        otherfilterValueFinal = undefined
      }
      
      this.isLoading = true;
      this.filter.otherFilterName = this.search.size > 0 ? this.RoleEmailFilter : "resourceName";
      this.filter.otherFilterValue = otherfilterValueFinal
      var tableData = [];
      let localStorageRealm = localStorage.getItem("originalLoginRealm")
      if(localStorageRealm === '/EA' || localStorageRealm === 'EA' || localStorageRealm === 'EA/'){
        try {
          tableData = await axios.get(
            `${process.env.VUE_APP_IDM_URL}/endpoint/eaActiveCompletedRequests?filter=` + JSON.stringify(this.filter)
          );
        } catch (error) {
          console.error(error);
          this.forbidden = true;
        }
      } else {
        try {
          tableData = await axios.get(
            `${process.env.VUE_APP_IDM_URL}/endpoint/activeCompletedRequests?filter=` + JSON.stringify(this.filter)
          );
        } catch (error) {
          console.error(error);
          this.forbidden = true;
        }
      } 

      this.searched = Object.values(tableData.data.data);
      this.pagedResultsCookie = tableData.data.pagedResultsCookie;
      this.isLoading = false;
    },
    onSelect(item) {
      if (!this.filter.completed) {
        this.selectedActive = item;
        this.selectedCompleted = null;
        this.$refs[this.ActiveTaskModalId].show();
      } else {
        this.selectedCompleted = item;
        this.selectedActive = null;
        this.$refs[this.CompletedTaskModalId].show();
      }
    },
    // searchStringTrim(search){
    //   var finalstring = (search.map((item) => item.trim())));
    //   console.log(finalstring)
    //   return finalstring
    // }
  },
};
</script>

<style lang="scss" scoped>
.actionStyle {
  font-size: 20px;
  font-weight: 900;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #1a73e8;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s infinite linear;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.selected-row {
  background-color: lightblue;
}

.inarow {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  margin: 10px;
  height: 40px;
}

.buttonSize {
  width: 40%;
}

.searchSize {
  width: 48%;
  margin-top: 20px;
}
.searchSizeButton{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap:50px;
}

.buttonrow {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.searchrow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

md-table {
  margin-top: 16px;
}

.paginationStyle {
  width: 20px;
  border: 1px solid #9d9d9f;
}

.paginationPageSize {
  width: 100px;
}

.footerPagination {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
</style>
